/**
 * @author Evgenij Tyan
 * @version 1.0.1
 * @since 1.0.0
 */

import { SagaIterator } from 'redux-saga';
import { all, takeEvery } from 'redux-saga/effects';

import {
    CLEAR_FILTER,
    DELETE_EXTFILTER,
    LOAD_EXTFILTER,
    SAVE_EXTFILTER,
    SEND_EXTFILTER,
    UPDATE_EXTFILTER,
} from '../constants/extFilterApiConstants';
import { SET_EXTFILTER_ID, SET_EXTFILTER_ITEM } from '../constants/extFilterConstructorConstants';
import {
    clearFilterSaga,
    deleteExtFilterSaga,
    loadExtFilterSaga,
    saveExtFilterSaga,
    sendExtFilterSaga,
    updateExtFilterSaga,
} from './extFilterApiSaga';
import { updateExtFilterIdSaga, updateExtFilterItemsSaga } from './extFilterConstructorSaga';

export function* initSubscriberExtFilter(): SagaIterator {
    yield all([
        takeEvery(CLEAR_FILTER, clearFilterSaga),
        takeEvery(DELETE_EXTFILTER, deleteExtFilterSaga),
        takeEvery(LOAD_EXTFILTER, loadExtFilterSaga),
        takeEvery(SAVE_EXTFILTER, saveExtFilterSaga),
        takeEvery(SEND_EXTFILTER, sendExtFilterSaga),
        takeEvery(SET_EXTFILTER_ID, updateExtFilterIdSaga),
        takeEvery(SET_EXTFILTER_ITEM, updateExtFilterItemsSaga),
        takeEvery(UPDATE_EXTFILTER, updateExtFilterSaga),
    ]);
}
